<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteContactConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("contacts.status_placeholder")' :danger="$v.newRecord.status.$invalid && $v.newRecord.status.$model" danger-text="Requerido" v-model="newRecord.status" :label='$t("contacts.status")')
            vm-select-item(value="1" text="Espera")
            vm-select-item(value="2" text="Atendido")
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Contacts')

export default {
  name: 'ModalContacts',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      status: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'contactsCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('contacts.add') : this.$t('contacts.edit')
    }
  },
  methods: {
    ...mapActions([
      'addContact',
      'editContact',
      'deleteContact',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.newRecord.user_id = this.$auth.user().id
      this.isAdd ? this.addContact(this.newRecord) : this.editContact(this.newRecord)
    },
    async deleteContactConfirm (contact) {
      let t = this
      this.auxDeleteContact = () => {
        t.deleteContact(contact)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(contact.name) }),
        accept: this.auxDeleteContact
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
